class GWPCampaigns extends HHBaseElement {
  constructor() {
    super()
  }
  
  connectedCallback() {
    this.openOnlyCampaign()
    this.removeIneligibleCartLines()
  }

  openOnlyCampaign() {
    const $campaigns = this.querySelectorAll('gwp-campaign:not(.hidden)')
    if ($campaigns.length === 1 && $campaigns[0].querySelector('.js-gwp-toggle')) {
      $campaigns[0]?.setAttribute('open', '')
      $campaigns[0]?.$toggleButton?.setAttribute('aria-expanded', true)
    }
  }

  removeIneligibleCartLines() {
    const ineligibleCartKeys = [];
    this.querySelectorAll('gwp-campaign').forEach(($campaign) => {
      if ($campaign.getAttribute('data-is-eligible') === 'true') {
        return;
      }

      const lines = $campaign.getAttribute('data-gwp-lines-in-cart').split(',')
      lines.forEach((line) => {
        if (line && !ineligibleCartKeys.includes(line)) {
          ineligibleCartKeys.push(line);
        }
      })
    })

    if (!ineligibleCartKeys.length) {
      return;
    }

    const updates = ineligibleCartKeys.reduce((acc, val) => ({ ...acc, [val]: 0}), {});
    window.__CART__CONTROLLER__.updateQuantities(updates);
  }

  render($cartGifts) {
    if (!$cartGifts) {
      this.style.display = 'none'
      this.innerHTML = ''
      return
    }

    this.innerHTML = $cartGifts.innerHTML
    this.openOnlyCampaign();
    this.removeIneligibleCartLines();
    
    const swiper = this.querySelector('swiper-with-pagination swiper-container')
    if (swiper) {
      swiper.initialize();
    }
  }
}
window.customElements.define('gwp-campaigns', GWPCampaigns)

class GWPCampaign extends HHBaseElement {
  constructor() {
    super()
  }
  
  get isOpen() {
    return this.getAttribute('open') === '';
  }
  
  connectedCallback() {
    this.$toggleButton = this.querySelector('.js-gwp-toggle')
    this.$addAllButton = this.querySelector('.js-gwp-add-all')
  
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.$toggleButton?.addEventListener('click', this._handleToggle.bind(this))
    this.$addAllButton?.addEventListener('click', this._handleAddAll.bind(this))
  }
  
  disconnectedCallback() {
    this.$toggleButton?.removeEventListener('click', this._handleToggle.bind(this))
    this.$addAllButton?.removeEventListener('click', this._handleAddAll.bind(this))
  }

  open() {
    this.setAttribute('open', '')
    this.$toggleButton?.setAttribute('aria-expanded', true)
  }

  close() {
    this.removeAttribute('open')
    this.$toggleButton?.setAttribute('aria-expanded', false)
  }

  async _handleAddAll(e) {
    e.preventDefault();
    const items = [];
    const addedVariantIds = [];

    this.querySelectorAll('.js-in-cart-toggle-add')?.forEach((button) => {
      const variantId = button.getAttribute('data-value');
      if (variantId && !addedVariantIds.includes(variantId)) {
        addedVariantIds.push(variantId)
        items.push({
          id: variantId,
          quantity: 1,
          properties: {
            _gwp: true,
          }
        })
      }
    });

    if (!items.length) {
      return;
    }

    window.__CART__CONTROLLER__.addMultiple({ items });
  }

  _handleToggle(e) {
    e.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}
window.customElements.define('gwp-campaign', GWPCampaign)
